// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1AccountAppsImportSchema = z.object({
  job_id: z.optional(z.number().int()),
  account_app: z.object({
    parent_source: z.coerce.string(),
    parent_ids: z.array(z.unknown()),
  }),
});
